
import React from "react";

import "./Profile.css";
import CircleImageUpload from "../components/CircleImageUpload";
import ProfileCompletion from "../components/ProfileCompletion";
import BasicInfo from "../components/BasicInfo";
import ModuleRole from "../components/ModuleRole";
import ActionNotification from "../components/ActionNotification";
import InformationNotification from "../components/InformationNotification";
import ReadAction from "../components/ReadAction";
import ApprovalTransactions from "../components/ApprovalTransactions";
import UserActivity from "../components/UserActivity";
import ResetPassword from "../components/ResetPassword";
import MobileOtp from "../components/MobileOtp";


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faCheck, faUser } from "@fortawesome/free-solid-svg-icons";


const PersonalProfile = () => {

    return (
        <div className="container mt-6">
            <div className="profile-sec position-relative">
                <img className="w-100" src="./banner.webp" alt="Banner" />
                <div className="profile-row pb-3">
                    <div className="row align-items-center">
                        <div className="col-lg-4">
                            <div className="d-inline-block ml-20">
                                <CircleImageUpload />
                            </div>
                            <button className="btn btn-success btn-sm ml-20">
                                <FontAwesomeIcon icon={faCheck} className="mr-5" />Active
                            </button>
                            <div className="d-block ml-20 mt-3">
                                <h5>Naresh Audukoori</h5>
                                <ul>
                                    <li><FontAwesomeIcon icon={faEnvelope} className="text-primary mr-10" />
                                        naresh@gmail.com
                                    </li>
                                    <li><FontAwesomeIcon icon={faPhone} className="text-primary mr-10" />
                                        +91 000 000 0000
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="d-block mr-10 mt-4 float-end">
                                <div className="d-flex gap-10">
                                    <div className="text-center border-right pe-2">
                                        <FontAwesomeIcon icon={faUser} className="text-primary" />
                                        <span className="d-block text-primary f-14 fw-semibold">HR Connect</span>
                                    </div>
                                    <div className="text-center border-right pe-2">
                                        <FontAwesomeIcon icon={faUser} className="text-secondary" />
                                        <span className="d-block text-secondary f-14 fw-semibold">Finance</span>
                                    </div>
                                    <div className="text-center border-right pe-2">
                                        <FontAwesomeIcon icon={faUser} className="text-info" />
                                        <span className="d-block text-info f-14 fw-semibold">Admin</span>
                                    </div>
                                    <div className="text-center border-right pe-2">
                                        <FontAwesomeIcon icon={faUser} className="text-warning" />
                                        <span className="d-block text-warning f-14 fw-semibold">Project</span>
                                    </div>
                                    <div className="text-center border-right pe-2">
                                        <FontAwesomeIcon icon={faUser} className="text-success" />
                                        <span className="d-block text-success f-14 fw-semibold">Location</span>
                                    </div>
                                    <div className="text-center border-right pe-2">
                                        <FontAwesomeIcon icon={faUser} className="text-danger" />
                                        <span className="d-block text-danger f-14 fw-semibold">ESOP</span>
                                    </div>
                                    <div className="text-center border-right pe-2">
                                        <FontAwesomeIcon icon={faUser} className="text-primary" />
                                        <span className="d-block text-primary f-14 fw-semibold">Legal</span>
                                    </div>
                                    <div className="text-center pe-2">
                                        <FontAwesomeIcon icon={faUser} className="text-secondary" />
                                        <span className="d-block text-secondary f-14 fw-semibold">Approval Manager</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mt-3 mb-3">
                    <div className="card-block">
                        <ul className="nav nav-pills" role="tablist">
                            <li className="nav-item">
                                <a className="nav-link active" data-bs-toggle="pill" href="#overview">Overview</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="pill" href="#notification">Notification</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="pill" href="#approval_transactions">Approval Transactions</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="pill" href="#user_activity">User Activity</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="pill" href="#reset_password">Reset Password</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" data-bs-toggle="pill" href="#mobile_otp">Mobile OTP</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="tab-content">
                    <div id="overview" class="tab-pane active">
                        <div className="row">
                            <div className="col-lg-3">
                                <ProfileCompletion />
                            </div>
                            <div className="col-lg-9">
                                <BasicInfo />
                                <ModuleRole />
                            </div>
                        </div>
                    </div>
                    <div id="notification" class="tab-pane fade">
                        <div className="row">
                            <div className="col-lg-4">
                                <ActionNotification />
                            </div>
                            <div className="col-lg-4">
                                <InformationNotification />
                            </div>
                            <div className="col-lg-4">
                                <ReadAction />
                            </div>
                        </div>
                    </div>
                    <div id="approval_transactions" class="tab-pane fade">
                        <div className="row">
                            <div className="col-lg-12">
                                <ApprovalTransactions />
                            </div>
                        </div>
                    </div>
                    <div id="user_activity" class="tab-pane fade">
                        <UserActivity />
                    </div>
                    <div id="reset_password" class="tab-pane fade">
                        <ResetPassword />
                    </div>
                    <div id="mobile_otp" class="tab-pane fade">
                        <MobileOtp />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonalProfile;